var Marionette = require('backbone.marionette');

var DeleteConfirmationModal = Marionette.View.extend({
    template: require('../../templates/common/delete-confirmation-modal.html'),

    ui: {
        modal: '#delete-confirmation-modal',
        btn: '#remove',
        close: '#close',
        confirmationText: '#confirmation'
    },

    events: {
        'click @ui.btn': 'deleteConfirmed'
    },

    templateContext: function(){
        var that = this;
        return{
            title: that.title || 'Confirmation of delete',
            message: that.message || 'Enter: "confirm" if you agree to remove.',
            confirmationAnswer: that.confirmationAnswer
        }
    },

    initialize: function(options){
        _.bindAll(this, 'onRender', 'deleteConfirmed', 'show');
        if (options){
            this.title = options.title;
            this.message = options.message;
            this.confirmationAnswer = options.confirmationAnswer.trim().toLowerCase();
        }
    },

    onRender: function(){
    },

    deleteConfirmed: function() {
        if (this.confirmationAnswer === this.ui.confirmationText.val().trim().toLowerCase()) {
            this.ui.modal.modal('hide');
            $('body').removeClass('modal-open');
            $('.modal-backdrop').remove();
            this.triggerMethod('delete:confirmed', true);
        }
    },
    
    show: function() {
        this.ui.modal.modal({backdrop: 'static', keyboard: false});
    }

});

module.exports = DeleteConfirmationModal;


//////////////////
// WEBPACK FOOTER
// ./app/views/common/delete-confirmation-modal.js
// module id = 241
// module chunks = 0